import { getTemplateStopTypeString } from "services/enums/TemplateStopType";
import { DateService } from "services/util/DateService";

const Columns = {
  streetAndNumber: {
    name: 'streetAndNumber',
    header: ({ t }) => t('streetAndNumber'),
    body: ({ templateStop }) => templateStop.address?.streetAndNumber || '-'
  },
  zipcode: {
    name: 'zipcode',
    header: ({ t }) => t('zipcode'),
    body: ({ templateStop }) => templateStop.address?.zipcode || '-'
  },
  deliveryWindow: {
    name: 'deliveryWindow',
    header: ({ t }) => t('deliveryWindow'),
    body: ({ templateStop }) => DateService.displayTime(templateStop?.deliveryWindow?.from) + ' - ' + DateService.displayTime(templateStop?.deliveryWindow?.to)
  },
  stopType: {
    name: 'stopType',
    header: ({ t }) => t('stopType'),
    body: ({ templateStop, t }) => t(getTemplateStopTypeString(templateStop?.stopType)) || '-'
  },
  name: {
    name: 'name',
    header: ({ t }) => t('name'),
    body: ({ templateStop, t }) => t(templateStop?.name) || '-'
  },
  stopCategory: {
    name: 'stopCategory',
    header: ({ t }) => t('stopCategory'),
    body: ({ templateStop, t }) => t(templateStop?.stopCategory) || '-'
  },
}

export default Columns;